// extracted by mini-css-extract-plugin
export var container = "SpeakerCard-module--container--1Xxka";
export var textWrap = "SpeakerCard-module--textWrap--3tX6Z";
export var image = "SpeakerCard-module--image--3P8ij";
export var background = "SpeakerCard-module--background--3ny4x";
export var FadeInUp = "SpeakerCard-module--FadeInUp--MLcp8";
export var FadeInUpMobile = "SpeakerCard-module--FadeInUpMobile--HXLRx";
export var FadeIn = "SpeakerCard-module--FadeIn--tG-ku";
export var Shiny = "SpeakerCard-module--Shiny--33LsE";